import Link from "@/components/AppLink";
import type { BreadcrumbEntry } from "@/types/content";

interface BreadcrumbProps {
  breadcrumbs?: BreadcrumbEntry[];
}

const Breadcrumb = ({ breadcrumbs }: BreadcrumbProps) => {
  return (
    <div className="breadcrumb-area">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb d-flex align-items-center">
          {breadcrumbs?.map(([itm, link], i, arr) => (
            <li
              className={`breadcrumb-item ${i === arr.length - 1 && "active"}`}
              key={itm}
            >
              {i !== arr.length - 1 ? <Link href={link}>{itm}</Link> : itm}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
